import { TInfoBlockColor } from 'components/UI/InfoBlock';
import {
  IGetMassCreativeAddTaskData,
  TRCreativeTypes,
} from 'domains/creative/types';
import { History, Location } from 'history';
import { Dispatch } from 'react';
import { TFunction } from 'react-i18next';
import { AnyAction } from 'redux';

// Описываем словарь шагов через константу, чтобы избежать конфликтов имен и переобъявлений
export const UPLOADSTAGELIST = {
  // Первичный экран
  Intro: 'INTRO',
  // Закинули файлы, пошла загрузка
  Upload: 'UPLOAD',
  // Архив в обраотке
  Processing: 'PROCESSING',
  // Ошибка загрузки архива
  ArchiveError: 'ARCHIVE_ERROR',
  // Результат - всё ок
  ResultSuccess: 'RESULT_SUCCESS',
  // Результат - частично ок
  ResultPartial: 'RESULT_PARTIAL',
  // Результат - ошибки сплошные
  ResultError: 'RESULT_ERROR',
} as const;

export type TUploadStepAction =
  | { type: 'UPLOAD_START' }
  | { type: 'PROCESSING' }
  | { type: 'ARCHIVE_ERROR' }
  | { type: 'UPLOAD_SUCCESS' }
  | { type: 'UPLOAD_PARTIAL' }
  | { type: 'UPLOAD_ERROR' };

// Определяем тип шагов на основе словаря, чтобы сохранить строгую типизацию
export type TUploadStep = typeof UPLOADSTAGELIST[keyof typeof UPLOADSTAGELIST];

export interface IPackageUploadModalProps {
  onCloseModal: () => void;
  xxhash?: string;
  task_id?: number;
  clickOutside?: boolean;
}
export type TInfoBlockConfigValue = {
  i18nKey: string; // Ключ для <Trans i18nKey="..." />
  color?: TInfoBlockColor; // Цвет блока
  customIcon?: React.ReactNode; // Иконка
  values?: Record<string, number>; // Значения для интерполяции в Trans
};

export type TUsePackageUploadModal = ({
  xxhash,
  task_id,
}: {
  xxhash: string | undefined;
  task_id: number | undefined;
}) => {
  t: TFunction<'translation'>;
  dispatch: Dispatch<AnyAction>;
  history: History<unknown>;
  step: TUploadStep;
  isLoading: boolean;
  uploadDispatch: React.Dispatch<TUploadStepAction>;
  files: File[];
  setFiles: React.Dispatch<React.SetStateAction<File[]>>;
  openId: 'green' | 'red' | undefined;
  task: IGetMassCreativeAddTaskData | null;
  isTaskLoading: boolean;
  textError: string;
  setTextError: React.Dispatch<React.SetStateAction<string>>;
  creativeTypes: TRCreativeTypes | null;
  location: Location<unknown>;
  handleToggle: (id: 'green' | 'red' | undefined) => void;
};
